import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Swal from "sweetalert2";

import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';

import { useDispatch, useSelector } from "react-redux";
import { fetchContactUsData } from "../../store/contact-us/actions";

import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button
} from "reactstrap";

const ContactUs = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data, loading, error } = useSelector(state => state.ContactUs);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  useEffect(() => {
    dispatch(fetchContactUsData());
  }, [dispatch]);

  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', options);
  }

  const columns = useMemo(
    () => [
      {
        header: 'User',
        accessorKey: 'user',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'User Type',
        accessorKey: 'user_type',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Title',
        accessorKey: 'title',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Date',
        accessorKey: 'date',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Action',
        id: 'action',
        cell: ({ row }) => {
          return (
            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-info"
                onClick={() => {
                  const fullRecord = data?.data?.find(item => item.id === row.original.id);
                  setSelectedData(fullRecord);
                  setModalOpen(true);
                }}
              >
                <i className="mdi mdi-eye"></i> View
              </button>
            </div>
          );
        }
      }
    ],
    [data]
  );

  const totalRecords = data?.data?.length ?? 0;

  const transformedData = useMemo(() => {
    return data?.data?.map(item => {
      return {
        id: item.id,
        user: item.user_name + ' (' + item.user_email + ')' || "N/A",
        user_type: item.user_type === 'C' ? 'Rider' : 'Driver',
        title: item.title || "N/A",
        date: formatDate(item.created_at) || "N/A",
      };
    });
  }, [data]);

  document.title = "Contact Us | Moeen";
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="Contact Us" />
        {loading ? (
          <Skeleton count={10} height={40} />
        ) : (
          <TableContainer
            columns={columns}
            data={transformedData || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder={`Looking for something? ${totalRecords} results loaded.`}
            pagination="pagination"
            paginationWrapper='dataTables_paginate paging_simple_numbers'
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        )}

        {/* Modal */}
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg" centered>
          <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
            Contact Us Details
          </ModalHeader>
          <ModalBody>
            {selectedData ? (
              <div>
                <p><strong>User:</strong> {selectedData.user_name} ({selectedData.user_email})</p>
                <p><strong>Phone:</strong> {selectedData.user_phone_code} {selectedData.user_mobno}</p>
                <p><strong>User Type:</strong> {selectedData.user_type === 'C' ? 'Rider' : 'Driver'}</p>
                <p><strong>Title:</strong> {selectedData.title}</p>
                <p><strong>Message:</strong></p>
                <div className="p-3 border rounded bg-light">
                  {selectedData.message}
                </div>
                <p className="mt-3"><strong>Date:</strong> {formatDate(selectedData.created_at)}</p>
              </div>
            ) : (
              <p>No data available.</p>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setModalOpen(false)}>Close</Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

ContactUs.propTypes = {
  t: PropTypes.any
};

export default ContactUs;
